<template>
  <div>
    <forms-letter-selector-vue
      ref='letterSelector'
      :characters="filteredLetters"
      :preSelectedLetter="selectedLetter"
      :allow_click_on_empty_letter="true"
      @update_letter="updateSelectedLetter"></forms-letter-selector-vue>
  </div>
</template>

<script>
import mixins from "common/mixins.js"

export default {
  name: 'search-alphabetical-facet-vue',
  components: {
    'search-date-facet-vue': () => import(/* webpackChunkName: "[request]" */ "components/search/DateFacet"),
    'forms-letter-selector-vue': () => import(/* webpackChunkName: "[request]" */ "components/forms/LetterSelector")
  },
  data() {
    return {
      selectedLetter: ""
    }
  },
  mounted() {
    this.visible=true
  },
  methods: {
    updateSelectedLetter(letterSelected){
      this.selectedLetter = letterSelected
    },
    do_clear() {
      var letterSelectorRef = Array.isArray(this.$refs.letterSelector) ? this.$refs.letterSelector[0] : this.$refs.letterSelector
      letterSelectorRef.updateSelectedLetter({letter: ''})
    }
  },
   computed: {
    filter_has_values() {
      return this.selectedLetter != "";
    },
    filteredLetters() {
      let lettersCount = []

      gon.characters.forEach(letter => {
        let facetLetter = this.facet.values.filter(facet_value => facet_value.name == letter)[0]
        let has_results = facetLetter != undefined ? facetLetter.total != 0 : false

        lettersCount.push({
          'letter': letter,
          'has_results': has_results
        })
      })
      return lettersCount
    }
   },
  watch: {
    selectedLetter(new_value) {
      this.$emit(
        'update_filter',
        this.name,
        new_value != '' ? [new_value] : [],
        this.facet.default_operator
      )
    },
    values(new_value, old_value) {
      if (new_value.length < old_value.length) {
        this.do_clear()
      }
    },
  },
  mixins: [mixins.facet],
};
</script>
